import { gql } from "@apollo/client";

export const GET_CUSTOMER_LOCATIONS = gql`
  query GetCustomerLocations {
    customerLocations {
      id
      location
    }
  }
`;

export const GET_SERVICE_LOCATIONS = gql`
  query GetServiceLocations {
    serviceLocations {
      id
      location
      is_active
    }
  }
`;

export const GET_LOCKER_LOCATIONS = gql`
  query GetLockerLocations {
    lockerLocations {
      id
      location
      is_active
    }
  }
`;
// Address pickers: covered zones, then official QNAS streets and buildings
export const GET_SERVICE_ZONES = gql`
  query GetServiceZones {
    serviceZones {
      id
      zone_number
      name
    }
  }
`;

export const GET_QNAS_STREETS = gql`
  query GetQnasStreets($zone: Int!) {
    qnasStreets(zone_number: $zone) {
      street_number
      name_en
    }
  }
`;

export const GET_QNAS_BUILDINGS = gql`
  query GetQnasBuildings($zone: Int!, $street: Int!) {
    qnasBuildings(zone_number: $zone, street_number: $street) {
      building_number
    }
  }
`;
